import { createModule } from '../utils/factories';
import permission from '../modules/permission';
import userPermission from '../modules/userPermission';

interface State {
  loaded: boolean;
  tokenIntervalId: string;
}

export default createModule({
  path: 'account',
  modules: [permission, userPermission],
  setup({ modules, getAccessors }) {
    const state = (): State => ({
      loaded: false,
      tokenIntervalId: typeof setTimeout,
    });

    const getters = {
      loaded: (state: State) => state.loaded,
      feVersionData: () => {
        const version = (import.meta.env.VUE_APP_VERSION || '').trim();
        return {
          version,
          changelog_link: version
            ? `https://sec-hub-api-changelog.s3-eu-west-1.amazonaws.com/CHANGELOG-fe-${version}.md`
            : '#',
        };
      },
    };

    const mutations = {
      setAccountLoaded(state: State, payload: { loaded: boolean }) {
        state.loaded = payload.loaded;
      },
      setTokenIntervalId(state: State, payload: { intervalId }) {
        state.tokenIntervalId = payload.intervalId;
      },
      clearTokenInterval(state: State) {
        clearTimeout(+state.tokenIntervalId);
        state.tokenIntervalId = null;
      },
    };

    const actions = {
      async loadAccount() {
        if (read(getters.loaded)()) {
          return Promise.resolve();
        }
        return Promise.all([
          modules.userPermission.public.dispatchLoadCurrentUserPermissions(),
          modules.permission.public.dispatchLoadFullResource(),
        ]).then(() => commit(mutations.setAccountLoaded)({ loaded: true }));
      },
    };

    const { read, commit, dispatch } = getAccessors<State>();

    return {
      module: {
        state,
        getters,
        mutations,
        actions,
      },
      public: {
        getLoaded: read(getters.loaded),
        getAppVersionData: read(getters.feVersionData),
        dispatchLoadAccount: dispatch(actions.loadAccount),
      },
    };
  },
});
